<div class="container">
  <mat-stepper
    orientation="vertical"
    [linear]="false"
    class="mat-elevation-z8"
    labelPosition="bottom"
    #loanProductStepper
  >
    <ng-template matStepperIcon="number">
      <fa-icon icon="pencil-alt" size="sm"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="edit">
      <fa-icon icon="pencil-alt" size="sm"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="done">
      <fa-icon icon="check" size="sm"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="error">
      <fa-icon icon="exclamation-triangle" size="lg"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="preview">
      <fa-icon icon="eye" size="sm"></fa-icon>
    </ng-template>

    <mat-step [stepControl]="loanProductDetailsForm">
      <ng-template matStepLabel>{{ 'labels.inputs.DETAILS' | translate }}</ng-template>

      <LOSx-loan-product-details-step
        [loanProductsTemplate]="loanProductsTemplate"
      ></LOSx-loan-product-details-step>
    </mat-step>

    <mat-step [stepControl]="loanProductCurrencyForm">
      <ng-template matStepLabel>{{ 'labels.inputs.CURRENCY' | translate }}</ng-template>

      <LOSx-loan-product-currency-step
        [loanProductsTemplate]="loanProductsTemplate"
      ></LOSx-loan-product-currency-step>
    </mat-step>

    <mat-step [stepControl]="loanProductSettingsForm">
      <ng-template matStepLabel>{{ 'labels.inputs.SETTINGS' | translate }}</ng-template>

      <LOSx-loan-product-settings-step
        [loanProductsTemplate]="loanProductsTemplate"
        [isLinkedToFloatingInterestRates]="loanProductTermsForm.get('isLinkedToFloatingInterestRates')"
        (advancePaymentStrategy)="advancePaymentStrategy($event)"
      >
      </LOSx-loan-product-settings-step>
    </mat-step>

    @if (isAdvancedPaymentStrategy) {
      <mat-step [stepControl]="loanProductInterestRefundForm">
        <ng-template matStepLabel>{{ 'labels.inputs.INTEREST REFUND' | translate }}</ng-template>
        <LOSx-loan-product-interest-refund-step
          [loanProductsTemplate]="loanProductsTemplate"
          (supportedInterestRefundTypes)="setSupportedInterestRefundTypes($event)"
        >
        </LOSx-loan-product-interest-refund-step>
        <LOSx-stepper-buttons></LOSx-stepper-buttons>
      </mat-step>
    }

    @if (isAdvancedPaymentStrategy) {
      <mat-step>
        <ng-template matStepLabel>{{ 'labels.inputs.PAYMENT ALLOCATION' | translate }}</ng-template>
        <LOSx-loan-product-payment-strategy-step
          [advancedPaymentAllocations]="advancedPaymentAllocations"
          [advancedCreditAllocations]="advancedCreditAllocations"
          [advancedPaymentAllocationTransactionTypes]="loanProductsTemplate.advancedPaymentAllocationTransactionTypes"
          [paymentAllocationOrderDefault]="loanProductsTemplate.advancedPaymentAllocationTypes"
          [advancedCreditAllocationTransactionTypes]="loanProductsTemplate.creditAllocationTransactionTypes"
          [creditAllocationOrderDefault]="loanProductsTemplate.creditAllocationAllocationTypes"
          (setPaymentAllocation)="setPaymentAllocation($event)"
          (setCreditAllocation)="setCreditAllocation($event)"
        >
        </LOSx-loan-product-payment-strategy-step>
        <LOSx-stepper-buttons></LOSx-stepper-buttons>
      </mat-step>
    }

    <mat-step [stepControl]="loanProductTermsForm">
      <ng-template matStepLabel>{{ 'labels.inputs.TERMS' | translate }}</ng-template>

      <LOSx-loan-product-terms-step [loanProductsTemplate]="loanProductsTemplate"></LOSx-loan-product-terms-step>
    </mat-step>

    <mat-step>
      <ng-template matStepLabel>{{ 'labels.inputs.CHARGES' | translate }}</ng-template>

      <LOSx-loan-product-charges-step
        [loanProductsTemplate]="loanProductsTemplate"
        [currencyCode]="loanProductCurrencyForm.get('currencyCode')"
        [multiDisburseLoan]="loanProductSettingsForm.get('multiDisburseLoan')"
      >
      </LOSx-loan-product-charges-step>
    </mat-step>

    @if (isAdvancedPaymentStrategy) {
      <mat-step [stepControl]="loanIncomeCapitalizationForm">
        <ng-template matStepLabel>{{ 'labels.inputs.DEFERRED INCOME RECOGNITION' | translate }}</ng-template>
        <LOSx-loan-product-capitalized-income-step
          [deferredIncomeRecognition]="deferredIncomeRecognition"
          [capitalizedIncomeCalculationTypeOptions]="loanProductsTemplate.capitalizedIncomeCalculationTypeOptions"
          [capitalizedIncomeStrategyOptions]="loanProductsTemplate.capitalizedIncomeStrategyOptions"
          [capitalizedIncomeTypeOptions]="loanProductsTemplate.capitalizedIncomeTypeOptions"
          [buyDownFeeCalculationTypeOptions]="loanProductsTemplate.buyDownFeeCalculationTypeOptions"
          [buyDownFeeStrategyOptions]="loanProductsTemplate.buyDownFeeStrategyOptions"
          [buyDownFeeIncomeTypeOptions]="loanProductsTemplate.buyDownFeeIncomeTypeOptions"
          (setViewChildForm)="setViewChildForm($event)"
        >
        </LOSx-loan-product-capitalized-income-step>
        <LOSx-stepper-buttons></LOSx-stepper-buttons>
      </mat-step>
    }

    <mat-step [stepControl]="loanProductAccountingForm">
      <ng-template matStepLabel>{{ 'labels.inputs.ACCOUNTING' | translate }}</ng-template>

      <LOSx-loan-product-accounting-step
        [loanProductsTemplate]="loanProductsTemplate"
        [accountingRuleData]="accountingRuleData"
        [loanProductFormValid]="loanProductFormValid"
        [deferredIncomeRecognition]="deferredIncomeRecognition"
      >
      </LOSx-loan-product-accounting-step>
    </mat-step>

    @if (loanProductFormValid) {
      <mat-step state="preview" completed>
        <ng-template matStepLabel>{{ 'labels.inputs.PREVIEW' | translate }}</ng-template>
        <LOSx-loan-product-preview-step
          [loanProductsTemplate]="loanProductsTemplate"
          [accountingRuleData]="accountingRuleData"
          [loanProduct]="loanProduct"
          (submitEvent)="submit()"
        >
        </LOSx-loan-product-preview-step>
      </mat-step>
    }
  </mat-stepper>
</div>
